/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const slideDtoSchema = z.object({
  index: z.optional(z.int()),
  thumbnailUrl: z.optional(z.string()),
  caption: z.string().nullish(),
});
